import axios from '@/utils'

// 非小游戏内情形下获取当前用户信息
export function get_user_info (params) {
    return axios({
        method: 'get',
        url: '/nfthouse/userinfo',
        params,
    })
}

// 非登陆下实名验证
export function non_login_idCard_verify (data) {
    return axios({
        method: 'post',
        url: '/users/nonLoginIdCardVerify',
        data,
    })
}

// 实名验证
export function real_id (data) {
    return axios({
        method: 'post',
        url: '/real_id',
        data,
    })
}
